import { render, staticRenderFns } from "./printer-details.vue?vue&type=template&id=1b58ca9c&"
import script from "./js/printer-details.js?vue&type=script&lang=js&"
export * from "./js/printer-details.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports